import { gql } from "@apollo/client/core";

export default gql`
    fragment Site_Minimal on Site {
        id
        title
    }
`
